import { Form } from 'formik';
import styled from 'styled-components';
export const SearchForm = styled(Form) `
  display: flex;
  flex-direction: column;
  height: 100%;
  position: relative;
`;
